import CustomListDropdown from '@/scenes/User/Settings/Privacy/AccessSettings/CustomListDropdown';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileSettingsAugmented } from '@/store/user/selectors/selectActiveProfileSettingsAugmented';
import { updateProfileSetting } from '@/store/user/thunks/updateProfileSetting';
import {
  getCustomListReadAccess,
  getInternalAccessSettings
} from '@/utils/privacy/accessCalculation';
import { AccessType } from '@/utils/privacy/types/AccessType';
import { useDispatch, useSelector } from 'react-redux';

function CustomListOption({ accessType }) {
  const dispatch = useDispatch();
  const [token] = useTokenState();
  const { activeProfileId } = useActiveProfile();

  const settings = useSelector(state =>
    selectActiveProfileSettingsAugmented(state, { activeProfileId })
  );

  const readAccess = getInternalAccessSettings(settings?.permissions?.access);

  const initialOptionsList =
    accessType === AccessType.allowCustomList
      ? readAccess?.allowCustomList
      : readAccess?.denyCustomList;

  function handleCustomListChange(options) {
    const newReadAccess = getCustomListReadAccess(accessType, options);
    dispatch(updateProfileSetting('permissions.access', newReadAccess, token));
  }

  return (
    <div style={{ margin: '0 0 28px', maxWidth: '300px' }}>
      <CustomListDropdown
        onChange={handleCustomListChange}
        initialOptions={initialOptionsList}
      />
    </div>
  );
}

export default CustomListOption;
